import { useState, useEffect } from "react";
import { Button, Divider, Header, Icon, Modal } from "semantic-ui-react";
import { Select, Checkbox, Input } from 'antd';
import apiJurados from "../../api/Jurados/api-jurados";
import fileDownload from "js-file-download";
import { ObjNotificaciones } from "../../config/notificaciones";
import getStorageUser from "../../middlewares/GetStorageUser"
import moment from "moment";
const { Option } = Select;
import './ExportarDatosJurado.scss';

export const ModalExportarDatosJurado = () => {
    const [open, setOpen] = useState(false);
    const [estado, setEstado] = useState("");
    const [fechaInicial, setFechaInicial] = useState("");
    const [fechaFinal, setFechaFinal] = useState("");
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState<any>({});

    const consultarReporteJurados = async () => {
        if (!estado || !fechaInicial || !fechaFinal) {
            return ObjNotificaciones.MSG_ERROR('warning', 'Información incompleta', 'Por favor, selecciona un estado, fecha incial y fecha final');
        }

        if (Number(moment(fechaFinal).diff(fechaInicial, "days")) > 182) {
            return ObjNotificaciones.MSG_ERROR('warning', 'Rango de fechas excedido', 'Solo puedes generar un reporte con un rango de fechas menor a 6 meses');
        }

        setLoading(true);
        let data = await apiJurados.juradosReporte(estado, fechaInicial, fechaFinal);
        fileDownload(data, 'reporte.xlsx');
        setLoading(false);
        return setOpen(false);
    }

    const getUser = async () => {
      try {
        const _user = getStorageUser()
        setUser(_user)
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      getUser();
    }, []);

    return (

        <Modal
            style={{
                height: 'auto',
            }}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            centered={true}
            closeIcon={
                <Icon
                    name="x"
                    style={{
                        color: "#9F0505",
                        position: "absolute",
                        right: 20,
                        top: 25,
                        cursor: "pointer",
                    }}
                />
            }
            trigger={
                <div className="col-12 justify-content-flex-end">
                    {
                        user.role_id == 1 ?
                        <Button className="button-azul-radius me-md-4">
                            Exportar datos de jurado
                        </Button>
                        : <span></span>
                    }
                </div>
            }
        >
            <Modal.Header>Exportar datos de jurados</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Header size="small" as="h2">
                        Estado de postulación
                    </Header>
                    <Divider />
                    <Select defaultValue="" style={{ width: "100%" }} onChange={(e) => {
                        setEstado(e)
                    }}>
                        <Option key={1} value="Todo">Todos los postulados</Option>
                        <Option key={2} value="Acepto">Aceptados</Option>
                        <Option key={3} value="No responde">No responde</Option>
                        <Option key={4} value="Sin verificar">Sin verificar</Option>
                        <Option key={5} value="Rechazo">Rechazado</Option>
                        <Option key={6} value="No acepto">No acepto</Option>
                        <Option key={7} value="Postulado">Postulado</Option>
                    </Select>
                    <Divider />
                    <div className="row">
                        <div className="col-12 col-md-6">
                            Desde
                            <Input type="date" onChange={(e) => setFechaInicial(e.target.value)} />
                        </div>
                        <div className="col-12 col-md-6">
                            Hasta
                            <Input type="date" onChange={(e) => setFechaFinal(e.target.value)} />
                        </div>
                    </div>
                    <Divider />
                    <Header size="small" as="label">
                        Seleccionar formatos
                    </Header>
                    <Divider />
                    <Checkbox.Group
                        style={{ display: "flex" }}
                        options={[".XLS"]}
                        defaultValue={[]}
                    />
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button className="button-gray-ghost" onClick={() => setOpen(false)}>
                    Cancelar
                </Button>
                <Button className="button-azul-radius" primary loading={loading} onClick={async () => {
                    consultarReporteJurados();
                }}>
                    Descargar
                </Button>
            </Modal.Actions>
        </Modal>

    );
};
